const es = {
    enter_code: "ID de sesión",
    connect: "Conectar",
    check_your_internet_connection: "Comprueba tu conexión a Internet.",
    network_error: "Error de red",
    server_error: "Error del Servidor",
    check_server_connection: "Error de servidor interno",
    downtime: "El tiempo de inactividad",
    server_is_currently_facing_downtime: "Servidor se enfrenta actualmente el tiempo de inactividad",
    show_what_you_see: "Mostrar lo que ves",
    by_joining_i_confirm_that_i_have_read_and_understand_the: "Confirmo que he leído y acepto la Política de privacidad.",
    privacy_policy: "Política de privacidad",
    invalid_code: "ID de sesión no válido",
    code_should_be_of_nine_digits: "El ID de sesión debe tener 9 dígitos.",
    blitzz: "Blitzz",
    please_enter_your_name: "Por favor, escriba su nombre",
    maximum_value_is_30: "Nombre debe ser inferior a 30 caracteres.",
    please_enter_meeting_id: "Por favor, introduzca su código de",
    please_try_again: "Inténtalo de nuevo.",
    no_one_is_sharing_video: "Nadie está compartiendo vídeo.",
    retry: "Procesar de nuevo",
    reconnect: "Re-Conexión",
    left_the_conversation: "abandonado la conversación",
    enabled_the_audio: "habilitado el audio",
    disabled_the_audio: "desactivado el audio",
    enabled_the_video: "permitido el video",
    disabled_the_video: "desactivado el video",
    failed_to_join_room: "No se ha podido unirse a la habitación",
    alert: "Alerta",
    override_video_sharing_message: "¿Quieres poner fin a la actual cuota de pantalla y comenzar a compartir su video?",
    override_screen_sharing_message: "¿Quieres poner fin al uso compartido de pantalla actual y comenzar a compartir la pantalla?",
    override_video_sharing_with_screen_capturing_message: "¿Le gustaría terminar el vídeo actual y comenzar a compartir la pantalla?",
    override_screen_sharing_with_video_sharing_message: "¿Quieres poner fin a la actual cuota de pantalla y comenzar a compartir su video?",
    yes: "Sí",
    cancel: "Cancelar",
    joined_the_call: "unido a la llamada",
    waiting_for_other_members_to_join_the_call: "Esperando a otros miembros a unirse a la llamada",
    warning: "Advertencia",
    camera_permission_disabled: "No se puede acceder cámara.",
    microphone_permission_disabled: "No se puede acceder al micrófono.",
    location_permission_disabled: "No se ha podido acceder a la ubicación.",
    storage_permission_disabled: "No se ha podido acceder al almacenamiento",
    permission_error_message_camera: "Por favor, activa la cámara de la configuración del dispositivo.",
    permission_error_message_microphone: "Por favor, activa el micrófono de configuración del dispositivo.",
    permission_location_error_message: "Por favor, activa ubicación desde la configuración del dispositivo.",
    permission_storage_error_message: "Por favor, activa el almacenamiento de la configuración del dispositivo.",
    give_permission: "Dar permiso",
    please_wait_for_five_seconds_to_take_screenshot: "Por favor, espere 5 segundos para tomar otra foto",
    please_wait_for: "Por favor espere",
    seconds_to_take_screen_shot: "segundos para tomar otra foto.",
    second_to_take_screen_shot: "segundos para tomar otra foto.",
    invalid_information_received_from_server: "información no válida recibida del servidor.",
    unable_to_share_screen_as_no_one_else_has_joined_the_conversation_yet:
        "No es posible compartir vídeo como nadie más ha unido a la conversación sin embargo,",
    successfully_uploaded: "Cargado con éxito",
    disconnected: "Desconectado",
    call_ended_as_no_one_else_had_joined_the_call: "Desconectada ya que nadie más unido.",
    application_update_required: "actualización de la aplicación requerida",
    update_required_message:
        "Parece como si estuviera en una versión anterior de la aplicación, por favor, actualice desde la tienda de aplicaciones.",
    update: "Actualizar",
    image_marking_started: "Imagen de marca comenzó",
    image_marking_stopped: "Imagen de marca se detuvo",
    settings: "ajustes",
    camera_permission_rationale: "Necesitamos acceso a la cámara. Por favor, dar permiso cámara",
    microphone_permission_rationale: "Necesitamos acceso a su micrófono. Por favor, dar permiso de micrófono",
    location_permission_rationale: "Necesitamos acceso a su ubicación. Por favor, dar permiso de ubicación",
    storage_permission_rationale: "Necesitamos acceso a su almacenamiento. Por favor, dar permiso de almacenamiento",
    call_between_two_customers: "El agente no se ha unido, por favor vuelva a intentar de nuevo en algún momento.",
    media_projection_permission_needed_for_screen_sharing: "el permiso de proyección medios necesarios para compartir la pantalla.",
    poor_network_connection: "¡Advertencia! conexión de red pobres",
    you_are_the_only_person_in_the_call: "Usted es la única persona en la llamada",
    image_has_been_captured_and_started_uploading: "La imagen se ha capturado y comenzó a subir",
    version: "Versión",
    please_enter_the_code_provided_to_you: "Por favor, introduzca el código proporcionado a usted.",
    start_screen_share: "Compartir pantalla",
    stop_screen_share: "Dejar de compartir",
    flip_camera: "flip Camera",
    take_photo: "Tomar foto",
    flash_off: "Flash apagado",
    flash_on: "Parpadeará en",
    start_markup: "inicio de marcado",
    stop_markup: "parada de marcado",
    speaker_off: "altavoz OFF",
    speaker_on: "altavoz en",
    more: "Más",
    close: "Cerrar",
    video_off: "OFF de vídeo",
    video_on: "video On",
    start_video: "Iniciar vídeo",
    stop_video: "Detener video",
    disconnect: "Desconectar",
    mute: "Mudo",
    muted: "Dejar de silenciar",
    powered_by_blitzz: "Desarrollado por Blitzz",
    connecting_your_call: "Conectado. Esperando a otros participantes.",
    connected: "Conectado",
    pin_is_of_nine_digit: "El pasador debe ser de 9 dígitos",
    preparing_image_for_markup: "Preparación para la imagen de marcas ...",
    clear_markup_confirmation: "Marcas de imagen clara de todos los usuarios?",
    clear_markup: "claro marcado",
    clear: "Claro",
    close_markup: "cerca de marcado",
    end_markup_confirmation: "¿Seguro que desea cerrar el marcado?",
    end: "Fin",
    agent_has_ended_markup_cannot_continue_without_agent: "El agente le ha terminado marcado. No se puede continuar sin agente de marcado",
    joining_image_markup: "Cargando la imagen de marcado ...",
    cleared_markup: "Marcas de imagen despejados para todos los usuarios.",
    capturing_photo: "La captura de foto ...",
    uploading: "Carga",
    image: "imagen",
    image_ready_for_markup: "Imagen lista para marcado.",
    override_video: "Esto detendrá el video de otra. ¿Quieres continuar?",
    override_screen_share: "Esto evitará que la pantalla compartida de otros. ¿Quieres continuar?",
    started_screen_share: "Compartir pantalla comenzado.",
    stopped_screen_share: "Dejado de compartir la pantalla.",
    clear_all: "Limpiar todo",
    start_new_call_popup: "Comenzar una nueva llamada con CÓDIGO",
    group_call_limit_reached: "límite de llamada de grupo alcanzó",
    contact_admin_to_increase_participant_limit: "Espere a que cualquier otro participante se desconecte y vuelva a intentarlo.",
    call_is_being_connected: "Se está conectada la llamada, por favor intente de nuevo más tarde.",
    show_recording_for_training_purpose: "Esta sesión está siendo grabada.",
    you_are_sharing_the_screen: "Estás compartiendo la pantalla",
    location_colon: "Ubicacion:",
    date_colon: "Fecha:",
    image_for_markup_has_been_downloaded: "Imagen para el marcado se ha descargado",
    dismiss: "Despedir",
    google_play_service_is_not_up_to_date: "servicio de juego Google no actualiza",
    rec: "Rec",
    you_are_offline: "Estas desconectado.",
    markup: "Margen",
    exit: "Salida",
    video_unsupported: "El video no soportado",
    please_open_this_link_in_safari: "Por favor, siga este enlace en Safari.",
    you_are_not_able_to_see_this_video: "Usted no es capaz de ver el vídeo.",
    only_number_Allowed: "Sólo se permiten números.",
    permission_warning: "advertencia permiso",
    unable_to_join_call_please_try_after_sometime: "Incapaz de unirse a la llamada. Por favor, intente después de algún tiempo",
    share_live_video: "Compartir el vídeo en directo?",
    share_your_screen: "¿Compartir tu pantalla?",
    unable_access_flash: "No se puede acceder luz de flash.",
    camera_unavailable_try_again: "Cámara no está disponible, inténtelo de nuevo.",
    unable_download_image_tomarkup: "No se puede descargar la imagen del servidor. Vuelva a intentarlo.",
    try_again: "Inténtalo de nuevo",
    markup_screen_appear_shortly: "Marca de pantalla aparecerá en breve ...",
    confirm: "Confirmar",
    start: "comienzo",
    could_not_find_endpoint: "No se pudo encontrar el servidor de punto final.",
    please_wait: "Por favor espera...",
    done: "Hecho",
    ok: "De acuerdo",
    please_try_again_with_valid_agent_id: "Por favor, inténtelo de nuevo con ID de agente válido.",
    meeting_code_not_associated_with_agent: "El ID de sesión no está asociado con este ID de agente.",
    powered_by: "Desarrollado por",
    failure: "Fracaso",
    code: "ID de sesión",
    start_new_call_question: "Comenzar una nueva llamada?",
    stop_sharing: "Deja de compartir",
    reconnecting_call: "Volver a conectar la llamada ...",
    unable_to_access_mircrophone_or_camera: "No se ha podido acceder al micrófono o la cámara.",
    be_sure_to_allow_access_in_browser: "Asegúrese de permitir el acceso en la configuración del navegador.",
    make_sure_you_have_microphone_camera_attached: "Asegúrate de que tienes la cámara o micrófono conectado.",
    location_blocked_by_user: "Ubicación bloqueados por el usuario",
    user_has_joined_the_call: "El usuario ha unido a la llamada",
    are_you_sure_you_want_to_close_window: "¿Seguro que desea cerrar esta ventana?",
    reset_guide: "guía de reposición",
    open_in_google_maps: "Abrir en Google Maps",
    location_image_upload_failed: "No se pudo subir la imagen Localización",
    uploading_image: "la imagen subida",
    upload_failed: "Subida fallida",
    markup_is_in_progress: "Marcado es inprogress ...",
    select_language: "Seleccione el idioma",
    checking_for_extension: "Comprobación de la extensión ...",
    start_incognito_mode_from_blitzz_screen_share_ext:
        "Para iniciar la cuota de pantalla en el modo de incógnito que necesita para iniciar el modo incógnito de Blitzz - Screen Share extensión de su navegador.",
    click_on: "Haga clic en",
    customize_and_control_menu: "Personalizar y controlar el menú",
    more_tools: "Más herramientas",
    extensions: "extensiones",
    click_on_detail: "Haga clic en detalle (Blitzz)",
    allow_in_incognito: "Permitir modo incógnito.",
    screen_share: "Compartir pantalla",
    stop_share: "Compartir parada",
    save: "Salvar",
    cancel_initcap: "Cancelar",
    yes_initcap: "Sí",
    message_title: "Mensaje",
    device_not_compatible: "Lo sentimos, este dispositivo no es compatible.",
    please_download_our_app: "Por favor, descargue nuestra aplicación para continuar.",
    download_app: "Descargar aplicación",
    this_browser_is_not_supported: "Este navegador no es compatible actualmente.",
    open_in_chrome_or_install_mobile_app:
        "Copie y pegue este enlace en la última versión de Google Chrome o instale nuestra aplicación móvil y vuelva a intentarlo.",
    open_in_safari_or_install_mobile_app:
        "Copie y pegue este enlace en la última versión del navegador Safari o instale nuestra aplicación móvil y vuelva a intentarlo.",
    open_in_chrome_and_try_again: "Por favor, siga este enlace en la última versión de Google Chrome y vuelve a intentarlo.",
    okay_initcap: "Bueno",
    would_you_like_to_install_app_or_continue_browser:
        "¿Le gustaría instalar nuestra aplicación para unirse a reuniones o continuar con el navegador?",
    continue_initcap: "Continuar",
    webview_limited_support_message: "Para obtener la mejor experiencia, ábralo en el navegador Chrome o en su navegador predeterminado.",
    continue_anyway: "Continuar de todos modos",
    open_in_browser: "Abrir en el navegador",
    link_copied_open_in_browser: "¡Enlace copiado! Si el navegador no se abre, pega el enlace en Chrome.",
    add_blitzz_extension_to_screen_share: "Añadir extensión Blitzz de cuota de pantalla",
    add_to_chrome_and_confirm: "'Añadir a Chrome y confirmar'",
    add_extension: "Añadir Extensión",
    permission_error_message_camera_browser: "Por favor, activa la cámara desde la configuración del navegador.",
    camera_not_found: "Cámara no encontrada",
    enable_camera_and_reconnect_call: "Necesita habilitar su cámara, vuelva a cargar la página y volver a conectar la llamada.",
    permission_error_message_microphone_browser: "Por favor, activa el micrófono de configuración del navegador.",
    permission_error_message_location_browser: "Habilite la ubicación desde la configuración del navegador.",
    microphone_not_found: "El micrófono no encontrado",
    enable_microphone_and_reconnect_call: "Necesita habilitar el micrófono, vuelva a cargar la página y volver a conectar la llamada.",
    download_failed: "Descarga fracasó",
    continue_markup: "continuar marcado",
    save_and_exit: "Guardar y Salir de marcado",
    exit_markup: "marcado de salida",
    you_are_recording_the_conversation: "Ahora está grabando la conversación.",
    make_sure_participant_know_they_are_being_recorded: "Asegúrese de que los participantes saben que están siendo grabadas.",
    you_can_download_recordings_later: "Puede descargar el archivo grabado posteriormente.",
    share_without_joining_session_lanuch_showme_enter_code:
        "No se puede compartido de la pantalla sin unirse a una sesión de ShowMe. Por favor lanzar ShowMe por Blitzz, e introduzca el código proporcionado a usted.",
    call_limit_reach_contact_Admin_to_increase_limit:
        "límite de llamada de grupo alcanzó. Por favor, póngase en contacto con su administrador para aumentar el límite de participante o esperar a que un miembro de abandonar la sesión.",
    other_user_trying_share_screen_Video: "Otro usuario está tratando de pantalla de vídeo o compartir",
    call_has_ended: "Llamada ha terminado",
    would_you_like_to_save_image: "¿Le gustaría guardar la imagen?",
    audio_unsupported: "audio no compatible",
    please_install_our_app_to_continue: "Por favor instalar nuestra aplicación para continuar.",
    unable_to_play_remote_audio: "No se puede reproducir el audio remoto.",
    unable_to_playback_audio: "Incapaz de reproducción de audio.",
    unable_to_play_video: "No se puede reproducir vídeo.",
    unable_to_playback_video: "No puede reproducir vídeo.",
    okay_cap: "Okey",
    pre_call_test: "Prueba de prellamada",
    language: "Idioma",
    reset: "Reiniciar",
    zoom_in: "Acercarse",
    zoom_out: "Disminuir el zoom",
    headset: "Auriculares",
    bluetooth: "Bluetooth",
    live_pointer_enabled_message: "Comenzó puntero en vivo. Puedes mover el puntero arrastrando.",
    speaker: "Altavoz",
    live_pointer_disabled_message: "Detenido puntero vivo",
    pointer: "Puntero",
    network_quality: "Calidad de red",
    participant: "Partícipe",
    you: "(Tú)",
    reconnecting: "Reconectando",
    very_bad: "Muy mal",
    bad: "Malo",
    poor: "Pobre",
    good: "Bueno",
    excellent: "Excelente",
    loc: "Loc",
    expand: "Expandir",
    collapse: "Colapso",
    network: "Red",
    ocr_inprogress: "OCR está en progreso ...",
    select_area_extract_text: "Seleccionar área para extraer texto",
    text_copied: "Texto copiado",
    extract_text_from_image: "Extraer texto de la imagen ...",
    not_extract_text_from_image: "No se pudo extraer texto de la imagen.",
    try_again_clear_image_or_reselect_region: "Vuelva a intentarlo con una imagen clara o vuelva a seleccionar su región de extracción.",
    error: "Error",
    occured_while_receiving_doc: "Ocurrió al recibir el documento.",
    return_to_video: "Volver al video",
    save_entire_image: "Guardar todo",
    save_cropped_image: "Guardar recortado",
    text_copied_to_clipboard: "Haga clic para copiar",
    extract_text: "Extraer texto",
    stop_pointer: "Stop Pointer",
    do_not_rotate_the_phone_live_pointer_message:
        "Para una mejor experiencia de visualización, no gire el dispositivo mientras el puntero en vivo esté habilitado.",
    got_it_btn: "¡Lo tengo!",
    speed_test: "Prueba de velocidad",
    duration: "Duración",
    preparing_image_for_OCR: "Preparando imagen para procesamiento de texto ...",
    agent_extract_text_from_image: "Espere, el agente está extrayendo el texto de la imagen capturada.",
    unable_download_image_to_ocr: "No se puede descargar la imagen para procesarla. Vuelva a intentarlo.",
    selected_area_is_small: "El área seleccionada es demasiado pequeña,",
    please_select_large_area: "Por favor seleccione un área grande de la imagen.",
    zoom_level: "Nivel de zoom",
    do_not_rotate_the_phone_markup_message:
        "Para una mejor experiencia de visualización, no gire el dispositivo mientras esté habilitado el marcado.",
    capturing: "Capturando ...",
    upload_completed: "Subida completada",
    network_quality_not_available: "Calidad de red no disponible",
    not_able_to_see_your_stream: "wno podrá ver tu transmisión.",
    device_not_supported: "Dispositivo no compatible.",
    video_settings_need_to_be_configured_by_admin_web:
        "As configurações de vídeo precisam ser definidas pelo seu administrador para suportar este dispositivo. Entre em contato com o administrador da empresa ou envie um email para",
    contact: "Contacto",
    video_paused_by_agent: "Video pausado por el agente",
    not_shared: "No compartido",
    network_type: "Tipo de red",
    image_thumb_caption: "Imagen:",
    saved_images: "Imágenes guardadas",
    update_your_browser_to_share_your_screen: "Actualice su navegador a la última versión para compartir su pantalla",
    try_these_option_to_have_better_experience: "Pruebe una de estas opciones para una mejor experiencia.",
    some_features_are_not_supported_in_this_browser: "Algunas funciones no son compatibles con este navegador.",
    unsupported_browser: "Navegador no soportado",
    permission_message_for_screenshare:
        "Se denegaron los permisos para acceder al área de la pantalla, o su instancia actual del navegador no tiene permisos para acceder al recurso compartido de pantalla.",
    go_to_system_preferences: "Ir a Preferencias del sistema",
    security_privacy: "Seguridad y Privacidad",
    select_privacy_tab: "Seleccionar pestaña de privacidad",
    screen_recording: "Grabación de pantalla",
    select_your_browser: "Selecciona tu navegador",
    use_chrome_to_share_your_screen: "Use el navegador Chrome o Firefox para compartir su pantalla",
    there_was_an_error_trying_to_share_your_video: "Se produjo un error al intentar compartir tu video.",
    please_stop_video_and_start_video_again_to_resume: "Detenga el video e inicie el video nuevamente para continuar.",
    decline: "Disminución",
    agree: "De acuerdo",
    click_the_padlock: "Haga clic en el candado",
    to_the_left_of_a_web_page_address: "a la izquierda de la barra de direcciones.",
    clear_blocked_permission_for_share_the_screen: "Borre todos los permisos bloqueados para compartir pantalla en la sección de permisos.",
    tips_colon: "Consejos:",
    your_internet_connection_is_unstable: "Tu conexión a internet es inestable",
    participants_connection_unstable: "La conexión a Internet de <participantNum> es inestable",
    enter_text_here: "Introducir texto aquí",
    text: "Texto",
    rect: "Rect",
    draw: "Dibujar",
    try_our_mobile_app: "Abrir en la aplicación",
    still_facing_issue_connect_mobile_app: "Si aún tiene problemas, conéctese con nuestra aplicación móvil.",
    open_in_app: "Abrir en la aplicación",
    enable_microphone_from_browser_settings: "Habilite el micrófono desde la configuración del navegador.",
    enable_camera_from_browser_settings: "Habilite la cámara desde la configuración del navegador.",
    unable_to_access_microphone: "No se puede acceder al micrófono",
    participants_title: "Participantes",
    bookmarks_title: "Marcadores",
    search_or_add_new_bookmark: "Buscar o agregar nuevo marcador",
    create_new_bookmark: "Crear nuevo marcador",
    press_enter_or_click_on_create_new_bookmark: "Presione Entrar o haga clic en Crear nuevo marcador para agregar un nuevo marcador",
    tap_retry_to_load: "Toque Reintentar para cargar",
    bookmark_saved_with_image: "Marcador guardado con imagen.",
    bookmark_saved: "Marcador guardado",
    bookmark_added: "Marcador agregado.",
    failed_to_bookmark_please_try_again: "Error al marcar Inténtalo de nuevo.",
    special_characters_are_not_allowed: "Caracteres especiales no están permitidos.",
    home_screen: "Pantalla de inicio",
    privacy_policy_popup_text_description:
        "Entiendo y acepto usar voluntariamente mi cámara para compartir una vista de mi entorno para resolver los problemas técnicos que tengo. Entiendo que no se realizará ni se guardará ninguna grabación. Puedo desactivar la función para compartir en cualquier momento. No apuntaré la cámara a áreas, individuos o elementos cuya imagen no deseo compartir. También confirmo que he leído y acepto la Política de privacidad.",
    audio_issue_ios: "Problema de audio?",
    toggle_mic_icon_guest_msg: "Cambia el ícono rojo de micrófono / cámara arriba, o usa el audio de una llamada telefónica (PSTN)",
    toggle_mic_icon_agent_msg:
        "Solicite al usuario de iOS que cambie el ícono rojo de micrófono / cámara de arriba, o use el audio de una llamada telefónica (PSTN)",
    audio_ios_msg_read_more: "Lee mas",
    error_occured_in_processing_the_request: "Se produjo un error al procesar la solicitud. Inténtalo de nuevo.",
    markup_ocr_upload_timeout: "Tardar más de lo habitual.",
    cancel_markup: "Cancelar marcado",
    markup_cancelled: "Marcado cancelado",
    cancel_ocr: "Cancelar Extraer texto",
    ocr_cancelled: "Extraer texto cancelado",
    click_here: "haga clic aquí",
    to_return_to_video_and_try_again: "para volver a Video e intentar nuevamente.",
    test_connection: "Conexión de prueba",
    markup_exit: "detenido El marcado",
    ocr_exit: "detenido Extraer texto",
    camera: "Cámara",
    camera_blocked: "Cámara bloqueada",
    microphone: "Micrófono",
    microphone_blocked: "Micrófono bloqueado",
    speakers: "Altavoces",
    speakers_blocked: "Altavoces bloqueados",
    grant_permission: "Conceder permiso",
    play_test_sound: "Reproducir sonido de prueba",
    call_settings: "Ajustes de llamada",
    allow_access_to_camera: "Permita el acceso a su cámara.",
    allow_access_to_mic: "Permita el acceso a su micrófono.",
    default_label: "Defecto",
    do_not_rotate_the_phone_OCR_message:
        "Para una mejor experiencia de visualización, no gire el dispositivo mientras esté habilitado Extraer texto.",
    browser_not_supported: "Navegador no compatible",
    your_browser_not_support_video: "Su navegador no admite videollamadas.",
    open_link_in_google_samsung_browser: "Copie y pegue este enlace en la última versión del navegador de Internet Google Chrome o Samsung.",
    open_link_in_safari_browser: "Copie y pegue este enlace en la última versión del navegador Safari.",
    copy_link: "Copiar link",
    copy_code: "Código de copia",
    session_code_copy: "Se copió el ID de sesión en el portapapeles.",
    meeting_code_lable: "Código de reunión",
    add_participant_lable: "Añada participante",
    send_this_link_to_guest: "Enviar este enlace al invitado",
    send_an_email: "enviar un correo electrónico",
    or_label: "o",
    remote_mic_cam_error: "El micrófono / cámara del participante remoto tiene un error.",
    device_not_supported_or_permi_block: "O su dispositivo no es compatible o tienen permisos bloqueados.",
    remote_participant: "Participante remoto",
    microphone_unmuted: "Micrófono no silenciado",
    microphone_muted: "Micrófono silenciado",
    camera_on: "Cámara encendida",
    camera_off: "Cámara apagada",
    error_label: "error",
    cannot_start_video: "Cannot start video",
    failed_to_start_video_camera: "Failed to start the video camera.",
    please_select_another_camera_from_call_settings: "Please select another video camera from Call Settings.",
    please_select_another_video_camera: "Please select another video camera.",
    chat: "Charla",
    chat_info:
        "Los mensajes de chat son visibles para todos en la llamada. El historial de chat desaparecerá permanentemente cuando se desconecte, por diseño.",
    chat_input_placeholder: "Escribe un mensaje",
    participant_connected: "<participantCount> participante (s) conectados",
    click_to_share_invite: "Haz clic para compartir la invitación.",
    remote_flashlight_not_supported_on_guest_device_or_not_ready: "La linterna remota no es compatible con el dispositivo invitado o no está lista",
    pin_a_video_tile_above_to_use_this_feature: "Fija un mosaico de video arriba para usar esta función",
    pin_video_for_all_participants: "Pin de video para todos los participantes",
    return_to_gallery_view: "Regresar a la vista de galería",
    override_own_screen_share: "Su pantalla compartida se detendrá. ¿Quieres continuar?",
    override_own_video: "Tu video se detendrá. ¿Quieres continuar?",
    blur: "Difuminar",
    mask_lable: "Máscara",
    view_text: "Ver",
    arrow: "Flecha",
    recording_stopped: "Grabación detenida",
    error_recording_please_try_again: "Error de grabación. Vuelve a intentarlo.",
    error_recording_wait_or_disconnect_call:
        "Error de grabación. Espere a que el host deje de grabar o puede desconectarse y volver a unirse más tarde.",
    wait_for_recording: "Espere mientras comenzamos a grabar ...",
    max_participant_limit_for_recording:
        "Max. límite de participantes alcanzado durante la grabación. Espere a que el host deje de grabar o puede desconectarse y volver a unirse más tarde.",
    error_recording_all_participants: "Error al grabar a todos los participantes.",
    please_stop_and_restart_recording: "Detenga y reinicie la grabación.",
    some_participants_will_not_be_recorded: "Algunos participantes no serán registrados.",
    participant_limit_reached: "Se alcanzó el límite de participantes.",
    your_account_has_4_participant_limit_while_recording: "Su cuenta tiene un límite de 4 participantes durante la grabación.",
    disconnect_call: "Desconectar llamada",
    record_title: "Grabar",
    stop_recording_btn: "Para de grabar",
    back_to: "De regreso",
    cam_per_denied_msg: "Es posible que uno de sus participantes haya bloqueado el acceso a la cámara en su dispositivo. Para guiarlos, consulte",
    mic_per_denied_msg: "Es posible que uno de sus participantes haya bloqueado el acceso al micrófono en su dispositivo. Para guiarlos, consulte",
    cam_mic_per_denied_msg:
        "Es posible que uno de sus participantes haya bloqueado el acceso a la cámara y al micrófono en su dispositivo. Para guiarlos, consulte",
    per_denied_common_msg: "para obtener consejos rápidos para restablecer los permisos del navegador.",
    your_camera_block: "Tu cámara está bloqueada",
    your_microphone_block: "Tu micrófono está bloqueado",
    your_location_block: "Tu ubicación está bloqueada",
    we_cannot_access_your_camera: "No podemos acceder a tu cámara.",
    we_cannot_access_your_microphone: "No podemos acceder a su micrófono.",
    we_cannot_access_your_location: "No podemos acceder a su ubicación.",
    go_to_browser_settings: "Para dar acceso, vaya a la configuración de su navegador y luego haga clic aquí para volver a cargar la página.",
    still_facing_issue: "¿Sigues teniendo problemas?",
    try_the: "Prueba el",
    mobile_app: "aplicación movil",
    view_help_article: "Ver artículo de ayuda",
    enable_or_attach_camera_and_reconnect_call: "Debe habilitar o conectar la cámara, volver a cargar la página y volver a conectar la llamada.",
    enable_or_attach_microphone_and_reconnect_call:
        "Debe habilitar o conectar el micrófono, volver a cargar la página y volver a conectar la llamada.",
    start_rec_label: "Iniciar Rec.",
    stop_rec_label: "Detener Rec.",
    start_recording_tooltip_label: "Empezar a grabar",
    click_here_label: "haga clic aquí",
    cam_per_denied_title: "Cámara del participante remoto bloqueada",
    mic_per_denied_title: "Micrófono de participante remoto bloqueado",
    cam_mic_per_denied_title: "Cámara y micrófono del participante remoto bloqueados",
    these_instructions: "estas instrucciones",
    Whisper_on: "Susurro encendido",
    Whisper_off: "Susurro apagado",
    enable_whisper_tooltip_label: "Habilite el susurro para hablar con el anfitrión",
    host_can_hear_you_now: "El anfitrión puede escucharte ahora",
    mediate_lable: "Mediar",
    join_call_as_participant: "Unirse a la llamada como participante",
    observer_lable: "Observador",
    silent_observer_connect_alert_popup: "Als Beobachter verbunden. Ihr Mikrofon und Ihre Kamera sind stummgeschaltet.",
    click_mediate_if_you_would_like_to_join_as_a_participant: 'Klicken Sie auf "Vermitteln", wenn Sie als Teilnehmer mitmachen möchten.',
    guest_lable: "Huésped",
    Silent_observer_lable: "Observador silencioso",
    invite_participant_tooltip_lable:
        "El micrófono y la cámara se silenciarán para Silent Observer y no serán visibles para los participantes invitados.",
    send_link_silent_observer: "Envíe este enlace al observador silencioso.",
    join_as_mediator_title: "¿Únete como mediador?",
    join_as_mediator_popup_description:
        "¿Está seguro de que desea unirse a la llamada como participante? Haga clic en Confirmar a continuación y luego haga clic en Conectar en la siguiente pantalla para unirse como participante (mediador).",
    from_participant: "Del participante",
    download_key: "Descargar",
    download_not_supported_text: "La descarga no es compatible con su dispositivo.",
    undo: "Deshacer",
    redo: "Rehacer",
    color_label: "Color",
    overall_experience: "¿Experiencia general?",
    leave_comment: "Deja un comentario (opcional)",
    sent: "Expedido",
    send: "Enviar",
    view_unavailable: "Ver no disponible",
    whisper_label: "Susurro",
    thanks: "¡Gracias!",
    stop_recording_tooltip_label: "Regrese al modo de galería para detener la grabación.",
    save_image: "Guardar imagen",
    screenshare_mweb_text: "La pantalla compartida de su dispositivo requiere una aplicación. Conecte esta sesión desde la aplicación móvil.",
    disconnect_and_launchapp_btn: "Desconectar y ejecutar la aplicación",
    device_battery_low: "Batería del dispositivo baja",
    batteryinfo_tooltip: "Información de la batería del dispositivo",
    notes_lable: "Notas",
    new_note_lable: "Nueva nota",
    only_visible_to_you: "Solo visible para ti",
    empty_note: "Nota vacía",
    title_lable: "Título",
    delete_lable: "Eliminar",
    delete_Note: "Borrar nota",
    want_delete_this_note: "¿Estás seguro que quieres eliminar esta nota?",
    failed_delete_note: "No se pudo borrar la nota.",
    note_deleted_successfully: "Nota eliminada",
    failed_edit_note: "No se pudo editar la nota.",
    note_edited_successfully: "Nota actualizada",
    failed_add_note: "No se pudo agregar la nota.",
    note_added_successfully: "Nota agregada",
    screenshare_mweb_title: "Se requiere descarga de la aplicación",
    screenshare_mweb_desc1: "La pantalla compartida de su dispositivo requiere una aplicación.",
    screenshare_mweb_desc2: "para descargar la aplicación.",
    upcoming_event: "Evento proximo",
    scheduled_to_start_in: "Programado para comenzar en",
    please_wait_for_the_host_to_start_this_event: "Espere a que el anfitrión inicie este evento y vuelva a intentarlo.",
    image_deleted: "Imagen eliminada",
    failed_to_delete_image: "No se pudo borrar la imagen",
    are_you_sure_you_want_to_delete_image: "¿Estás seguro de que deseas eliminar esta imagen de forma permanente?",
    delete_image_title: "Eliminar Imagen",
    location_image_thumb_caption: "Imagen de ubicación",
    schedule_to_start_in_a_few_seconds: "Programado para comenzar en unos segundos.",
    edit_label: "Editar",
    scan_code_lable: "Código de escaneo",
    scan_code_result: "Resultado del código de escaneo",
    extract_text_result: "Extraer el resultado del texto",
    scan_code_result_not_found: "No se pudo escanear el código QR / código de barras de la imagen. Vuelva a intentarlo con una imagen clara.",
    host_features_will_not_be_available_when_using_app: "Las funciones de host no estarán disponibles al usar la aplicación.",
    note_colon: "Nota:",
    leave_lable: "Salir",
    are_you_sure_you_want_to_leave_this_call: "¿Estás seguro de que quieres salir de esta llamada?",
    supported_browser_versions: "Versiones de navegador compatibles.",
    see: "Ver",
    has_sent_you_link_for_video_conference: "<company_name> te ha enviado un enlace de videoconferencia en directo.",
    join_the_session: "Únete a la sesión",
    other: "Otro",
    share_invitation_with_others: "Compartir la invitación a la sesión con otros",
    copy_invitation: "Copiar la invitación a la sesión",
    copy_invitation_desc: "Copie el texto de la invitación con la hora programada y envíelo manualmente",
    copied: "Copiado!",
    copy_session_code: "Copiar ID de sesión",
    copy_link_to_share: "Copiar enlace para compartir",
    reference: "Referencia",
    session_invitation_copied: "Se copió la invitación a la sesión en el portapapeles.",
    guest_url_copy: "Invitado URL copiado al portapapeles.",
    observer_url_copied: "URL del observador copiada al portapapeles.",
    sms_sent_label: "SMS enviados!",
    email_sent_label: "¡Email enviado!",
    invite_sent_successfully: "Invitar enviado con éxito",
    sms_label: "SMS",
    copy: "Copiar",
    email: "Email",
    enter_valid_email: "Introduzca la dirección de correo electrónico válida.",
    limit_exceeded: "Límite excedido",
    enter_email_send: "Ingrese el correo electrónico para enviar una invitación",
    send_invitaion_lable: "Enviar invitacion",
    enter_mobile_number_lable: "Ingrese el número de celular",
    enter_valid_mobile: "Introduzca un numero de movil valido.",
    new_email_address: "Dirección de correo electrónico",
    mobile_number: "Número de teléfono móvil",
    video_quality: "Calidad de video",
    low_bandwidth: "Ancho de banda bajo",
    adaptive: "Adaptado",
    high_quality: "Alta calidad",
    wait_for_the_call_to_start: "Espera a que comience la llamada",
    call_disconnected: "Llamada desconectada",
    dont_show_this_again: "No vuelvas a mostrar esto",
    invite_participant_lable: "Invitar participante",
    saved_label: "¡Salvado!",
    show_stream: "mostrar",
    hide_stream: "Esconder",
    camera_permission_required_title: "Se requiere permiso de la cámara",
    camera_permission_required_disc1: "Para compartir video en vivo, active el permiso de la cámara en la configuración de su navegador y luego",
    reload_page_disc: "para recargar la página.",
    location_permission_required_title: "Se requiere permiso de ubicación",
    microphone_permission_required_title: "Se requiere permiso de micrófono",
    confirmation_lable: "Puedo confirmar que he leído y acepto las",
    live_location: "Ubicación en vivo",
    no_one_shared_location: "Nadie ha compartido su ubicación.",
    it_was_great_lable: "Fue grandioso",
    not_so_great_lable: "No muy bien",
    link_copied: "Enlace copiado",
    microphone_publication_description: "Micrófono no encontrado o puede estar siendo usado por otra aplicación.",
    please_close_all_other_application: "Cierre todas las demás aplicaciones que puedan estar usando el micrófono y vuelva a intentarlo.",
    app_to_share_your_device_screen: "Continúe esta llamada en la aplicación para compartir la pantalla de su dispositivo",
    launch_app: "Ejecutar aplicación",
    screen_share_requires_app: "La pantalla compartida requiere una aplicación.",
    only_takes_few_seconds: "Esto solo toma unos segundos.",
    download_app_from_app_store_and_then_return_page: "Descargue la aplicación de la App Store y luego regrese a esta página.",
    click_to_download_app: "Haga clic para descargar la aplicación",
    go_to_Step_2: "Si ya ha descargado la aplicación, vaya al paso 2",
    next_lable: "próximo",
    rejoin_the_call_in_app: "Vuelva a unirse a la llamada en la aplicación",
    step2_screen_share_description:
        'Una vez que haya descargado la aplicación, puede volver a unirse a esta llamada en la aplicación y seleccionar "Compartir pantalla" para compartir la pantalla de su móvil.',
    disconnect_the_call_in_browser: "Esto desconectará la llamada en el navegador.",
    back_btn_lable: "Atrás",
    rejoin_call_in_app: "Volver a unirse a la llamada en la aplicación",
    step_one: "Paso 1",
    step_two: "Paso 2",
    beta_release_tag_des1: "Esta función se encuentra actualmente en versión Beta.",
    email_support_feedback: "Envíe un correo electrónico a support@blitzz.co para compartir sus comentarios.",
    would_you_like_to_exit_markup: "¿Le gustaría salir del marcado?",
    current_position: "Posición actual",
    start_point: "Punto de partida",
    live_captions: "Subtítulos en vivo",
    starting_label: "A partir de...",
    live_captions_started: "Comenzaron los subtítulos en vivo.",
    spoken_language_is_set_to_english: "El idioma hablado se establece en inglés.",
    click_to_open_more_information: "Haga clic para abrir más información",
    open_in_safari_chrome_or_install_mobile_app:
        "Copie y pegue este enlace en la última versión de Safari o del navegador Google Chrome o instale nuestra aplicación móvil y vuelva a intentarlo.",
    continue_without_name: "Continuar sin nombre",
    enter_your_name: "Introduzca su nombre",
    ignore: "Ignorar",
    screen_share_info:
        "Para evitar un espejo infinito, no comparta toda su pantalla o ventana del navegador. Comparta solo una pestaña o una ventana diferente en su lugar.",
    screen_share_to_everyone: "Estás compartiendo la pantalla con todos.",
    stop_share_screen: "Dejar de compartir pantalla",
    unable_to_start_the_video_please_download_the_app_to_continue: "No se puede iniciar el video, descargue la aplicación para continuar.",
    upload: "Subir",
    from_device: "Desde el dispositivo",
    from_camera: "De la cámara",
    upload_failed_files: "Subir archivos fallidos",
    uploaded_max_file: "Ha subido la cantidad máxima de archivos permitidos.",
    upload_files: "Subir archivos",
    upload_limit_reached: "Límite de subida alcanzado",
    drop_for_upload_or_select: "Caiga aquí para cargar, o seleccione",
    upload_20_file: "Sube hasta 20 archivos a la vez.",
    max_size_20MB: "máx. tamaño de archivo <fileSize> MB.",
    cancel_upload: "Cancelar carga",
    cancel_upload_alert: "¿Cancelar carga?",
    file_details_deleted: "Cualquier detalle agregado a sus archivos será eliminado.",
    uploaded_files: "Archivos subidos",
    capture_image: "Capturar imagen",
    participant_uploading_file_msg: "Espere mientras el otro participante carga archivos.",
    previous: "Anterior",
    max_file_count: "Puede cargar un máximo de archivos <fileCount> a la vez.",
    removed_more_than_20MB_file: "Se eliminan los archivos de más de <fileSize> MB.",
    uploading_files: "Subiendo archivo(s)",
    upload_failed_file_count: "Carga fallida: los archivos <numberOfFailedFiles> no se cargaron.",
    add_caption: "Añadir un subtitulo...",
    uploaded_files_of_a_maximum: "Archivos <successCount> subidos, de un máximo de <totalCount>",
    you_have_selected_the_maximum_number_of_files_allowed: "Ha seleccionado el número máximo de archivos permitidos.",
    upload_max_count: "Cargue el máximo de archivos <remainingCount> .",
    image_upload_msg: "Espere mientras se cargan las imágenes.",
    finished_uploading: "Terminado de cargar",
    upload_files_msg: "Subir archivos",
    uploading_dots: "Subiendo…",
    loading_image_counter: "Cargando imagen <counter> de <totalCount>",
    closing_tab: "Cerrar pestaña",
    close_tab: "Cerrar pestaña",
    return_to_home_screen: "Volver a la pantalla de inicio",
    session_code_expire_msg: "Este enlace ha sido cerrado",
    view_call_logs: "Ver registros de llamadas",
    measurements: "Mediciones",
    copy_all: "Cópialo todo",
    measure: "Medida",
    view_supported_device: "Ver dispositivos compatibles",
    device_not_support_google_play_service:
        "El dispositivo del participante no es compatible con el servicio Google Play, que se requiere para las mediciones 3D",
    device_not_compatible_for_measurement: "Dispositivo no compatible para Medición",
    device_required_update_google_play_service:
        "El dispositivo del participante requiere actualizar Google Play Service para iniciar la medición 3D.",
    device_required_google_play_service: "El dispositivo del participante requiere la instalación de Google Play Service para iniciar la medición 3D",
    app_required_update_for_measurement: "Se requiere actualización de la aplicación de soporte para la medición",
    app_required_for_measurement: "Aplicación de soporte necesaria para la medición",
    preparing_ar_measurement: "Preparando vista para Medición...",
    measurement_copied_msg: "Medidas copiadas al portapapeles",
    ready_for_measurement: "Listo para medir",
    move_device_to_start: "Mover dispositivo para comenzar",
    tacking_not_available: "El seguimiento no está disponible",
    camera_use_bu_another_app: "La cámara está en uso por otra aplicación",
    more_light_required: "Se requiere más luz",
    move_further_away: "Muévete más lejos",
    slow_down: "Desacelerar",
    measurement_cancelled: "Medición cancelada",
    app_required: "Esta función requiere la descarga de la aplicación. <learnmore>",
    learn_more: "Aprende más",
    ar_measurement_description_step2:
        'Una vez que haya descargado la aplicación, puede volver a unirse a esta llamada en la aplicación y seleccionar "Medir" para iniciar la medición AR',
    ar_measurement_description_step1:
        "La función de medición de realidad aumentada le permite medir objetos en 3D y requiere una descarga de la aplicación",
    app_to_support_ar_measurement: "Continúe esta llamada en la aplicación para apoyar la medición AR",
    find_surface_to_measure: "Encuentre una superficie cercana para medir",
    measurement_toast_note_to_guide_user: "Nota: Las medidas son aproximadas.",
    measurement_toast_msg_to_guide_user:
        "Para obtener los mejores resultados, use Medir en objetos bien definidos ubicados de 0,5 a 3 metros (2 a 10 pies) de su teléfono.",
    having_audio_issue: "¿Tienes un problema de audio?",
    remote_participant_voice_not_coming_description:
        "Parece que actualmente tiene dificultades para escuchar la voz de otros participantes o experimenta algún tipo de problema de audio.",
    workaround_action_for_remote_audio_not_coming: "<click_here> para aplicar una solución rápida.",
    click_here_for_audio_label: "Haga clic aquí",
    measurement_copyall_msg: "Medidas copiadas al portapapeles",
    armarkup_cancelled: "Marcado AR cancelado",
    device_not_support_google_play_service_for_markup:
        "El dispositivo del participante no es compatible con Google Play Service, que es necesario para el marcado 3D",
    device_required_update_google_play_service_for_markup:
        "El dispositivo del participante requiere actualizar Google Play Service para iniciar 3D Markup.",
    device_required_google_play_service_for_markup:
        "El dispositivo del participante requiere la instalación de Google Play Service para iniciar el marcado 3D",
    device_not_compatible_for_AR_Markup: "Dispositivo no compatible con AR Markup",
    app_required_update_for_AR_Markup: "Se requiere actualización de la aplicación compatible para AR Markup",
    app_required_for_AR_Markup: "Aplicación de soporte requerida para AR Markup",
    preparing_view_for_ar_markup: "Preparando vista para AR Markup...",
    AR_Markup_Lable: "Marcado AR",
    armarkup_toast_msg_to_guide_user:
        "Para obtener los mejores resultados, use Marcado en objetos bien definidos ubicados a una distancia de 0,5 a 3 metros (2 a 10 pies) de su teléfono.",
    ar_live_streaming_ready_to_markup: "Transmisión en vivo AR lista para marcar.",
    ar_markups_cleared_for_all_users: "Marcas AR borradas para todos los usuarios.",
    ar_live_streaming_marking_stopped: "Se detuvo el marcado de transmisión en vivo AR",
    agent_has_ended_ar_markup_cannot_continue_without_agent: "El agente finalizó el marcado AR. No se puede continuar el marcado AR sin agente",
    ar_markup_cancelled: "Marcado AR cancelado",
    ready_for_ar_markup: "Listo para el marcado AR",
    max_ar_arrow_limit_toast_message: "Límite de flecha alcanzado, use borrar todo para agregar más.",
    video_paused: "video en pausa",
    discard_label: "Desechar",
    discard_image_label: "Descartar imagen",
    save_image_label: "Guardar imagen",
    go_room_call_limit_reached: "Se alcanzó el límite de llamadas de habitación",
    circle: "Círculo",
    arrow_with_text: "Flecha con texto",
    add_shadow_and_stroke: "Agregar sombra y trazo",
    font_label: "Fuente:",
    file_type_not_supported: "Tipo de archivo(s) no soportado",
    crt_acnt_enter_confirm_password: "",
    create_new_note_description: "Haga clic en el botón Nueva nota a continuación para comenzar a tomar notas.",
    remote_user_stream_interrupted: "Se interrumpió el flujo de usuarios remotos",
    audio_disabled_by_admin: "Audio deshabilitado por el administrador",
    audio_disabled: "Audio deshabilitado",
    dont_show_again: "No mostrar de nuevo",
    whatsapp_sent_label: "¡Invitación de WhatsApp enviada!",
    whatsapp_label: "WhatsApp",
    having_an_issue_with_joining_the_call: "¿Tiene algún problema para unirse a la llamada?",
    to_perform_network_check: "Para realizar una comprobación de red",
    you_were_removed_from_the_call_by_the_host: "El anfitrión te eliminó de la llamada.",
    you_have_been_removed_from_the_call_by_the_host_and_cannot_rejoin_now:
        "El anfitrión lo ha eliminado de la llamada y no puede volver a unirse ahora.",
    host_removed_you_from_the_call: "El anfitrión te eliminó de la llamada.",
    unable_to_join_the_call: "No se puede unir a la llamada",
    host_muted_your_microphone: "El anfitrión silenció su micrófono.",
    unmute_your_microphone: "Desactiva el sonido de tu micrófono",
    host_invites_you_to_speak_unmute_your_microphone_when_ready: "El anfitrión te invita a hablar. Activa el micrófono cuando estés listo.",
    got_it: "Entiendo",
    unmute_mic: "Activar el micrófono",
    host_turned_off_your_camera: "El anfitrión apagó su cámara.",
    turn_your_camera_on: "Enciende tu cámara",
    host_invites_you_to_turn_your_camera_on: "El anfitrión te invita a encender tu cámara.",
    turn_camera_on: "Encender la cámara",
    start_sharing_your_screen: "Empieza a compartir tu pantalla",
    host_invites_you_to_share_your_screen: "El anfitrión te invita a compartir tu pantalla.",
    share_screen: "Compartir pantalla",
    remove_all: "Eliminar todo",
    remove: "Eliminar",
    end_call: "Finalizar llamada",
    removing_all_participants_will_end_the_call: "Al eliminar a todos los participantes se finalizará la llamada.",
    are_you_sure_you_want_to_remove_from_this_call: "¿Está seguro de que desea eliminar <participantName> de esta llamada?",
    block_from_rejoining_this_call: "Impedir que <participantName> vuelva a unirse a esta llamada",
    turn_all_mics_off: "Apaga todos los micrófonos",
    turn_all_cams_off: "Apaga todas las cámaras",
    ask_to_turn_mic_on: "Pide que enciendan el micrófono",
    turn_mic_off: "Apagar el micrófono",
    turn_cam_off: "Apagar la cámara",
    ask_to_turn_cam_on: "Pide encender la cámara",
    ask_to_share_screen: "Solicitar compartir pantalla",
    having_a_video_problem: "¿Tienes un problema con el vídeo?",
    ios_play_pause_modal_body_text:
        "Intente desactivar el modo de ahorro de energía de su móvil para solucionar este problema o haga clic en el botón Reproducir a continuación para reproducir el video ahora.",
    play_video: "Reproducir vídeo",
    camera_request_sent: "Solicitud de cámara enviada.",
    waiting_for_host_approval: "Esperando la aprobación del anfitrión.",
    microphone_request_sent: "Solicitud de micrófono enviada.",
    camera_request_denied: "Solicitud de cámara denegada.",
    click_the_camera_icon_if_you_need_to_request_again: "Haga clic en el icono de la cámara si necesita solicitar nuevamente.",
    microphone_request_denied: "Solicitud de micrófono denegada.",
    click_the_mic_icon_if_you_need_to_request_again: "Haga clic en el icono del micrófono si necesita solicitar nuevamente.",
    deny: "Denegar",
    allow: "Permitir",
    user_wants_to_start_their_camera: "<ParticipantName> quiere iniciar su <micOrCam>",
    error_in_processing_live_caption_please_retry: "Error en el procesamiento del subtítulo en vivo, por favor vuelva a intentarlo.",
    virtual_background: "Fondo virtual",
    upload_image: "Subir imagen",
    remove_image: "Eliminar imagen",
    remove_background_image: "Eliminar imagen de fondo",
    are_you_sure_you_want_to_remove_background_image: "¿Estás seguro de que deseas eliminar la imagen de fondo?",
    unsupported_file_format: "Formato de archivo no compatible.",
    the_maximum_file_size_supported_is_in_mb: "El tamaño máximo de archivo admitido es <size> MB.",
    no_effect: "Sin efecto",
    blur_background: "Desenfocar el fondo",
    default_image: "Imagen predeterminada",
    virtual_background_not_supported: "Fondo virtual no compatible.",
    remove_from_call: "Quitar de la llamada",
    enable_offline_mode: "Habilitar el modo sin conexión",
    offline_mode_enabled: "Modo sin conexión habilitado",
    your_images_will_upload_when_you_reconnect: "Tus imágenes se cargarán cuando te vuelvas a conectar.",
    please_keep_this_screen_open: "Mantenga esta pantalla abierta.",
    max_images_upload: "Máximo <count> imágenes",
    remaining_image_count_label: "<remainingCount> de <totalCount> imágenes",
    selected_images: "Imágenes seleccionadas",
    offline_uploads_are_not_supported_in_private_mode: "Las cargas sin conexión no son compatibles con el modo privado.",
    please_switch_to_a_normal_browser_tab_to_use_this_feature: "Cambie a una pestaña normal del navegador para utilizar esta función.",
    guest_is_using_a_private_browser_window: "El invitado está utilizando una ventana de navegador privada.",
    offline_upload_mode_is_not_supported_in_this_case: "El modo de carga sin conexión no es compatible en este caso.",
    some_images_failed_to_upload_due_to_a_network_error: "Algunas imágenes no pudieron cargarse debido a un error de red.",
    closing_this_modal_will_discard_all_the_images_you_have_selected_during_offline_mode:
        "Al cerrar este modal se descartarán todas las imágenes que haya seleccionado durante el modo sin conexión.",
    live_captions_stopped: "Los subtítulos en vivo se detuvieron.",
    translate: "Traducir",
    auto_translate: "Traducción automática",
    your_language: "Tu idioma",
    translation_info_text: "Los mensajes de otros participantes se traducirán automáticamente a tu idioma seleccionado.",
    translating: "Traduciendo...",
    show_original: "Mostrar original",
    show_translation: "Mostrar traducción",
    translated: "Traducido",
    send_message_in: "Enviar mensaje en",
    audio_translation: "Traducir",
    audio_translation_setup: "Traducción de Audio",
    they_speak: "Ellos hablan",
    i_want_to_hear: "Quiero escuchar",
    start_translation: "Iniciar Traducción",
    stop_translation: "Detener Traducción",
    starting_translation: "Iniciando traducción...",
    translation_started: "Traducción de audio iniciada.",
    translation_stopped: "Traducción de audio detenida.",
    translation_error: "Error de traducción. Por favor, inténtelo de nuevo.",
    translation_active: "Traducción activa",
    voice_type: "Voz",
    voice_female: "Femenina",
    voice_male: "Masculina",
};

export default es;
